/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';

import {TreeNode} from '../../../ui/tree-select/tree-select.component';
import {AbstractField} from '../abstract-field';

/**
 * An tree widget to select a value from a tree
 */
@Component({
  selector: 'gp-form-field-tree',
  template: `
    <gp-tree-select
      class="form-control"
      [tree]="roots"
      [attr.test-id]="descriptor.zoneID"
      [formControl]="control"
      [(ngModel)]="value.value"
      (ngModelChange)="addTransId($event)"
      [readOnly]="readOnly"
      [isSorted]="true"
      [parentScrollSelector]="parentScrollSelector"
      ngDefaultControl
    >
    </gp-tree-select>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreeFieldComponent extends AbstractField implements OnInit {

  public parentScrollSelector: string;

  public roots: Array<TreeNode<any>> = [];

  public lookupMap: Map<number, TreeNode<any>> = new Map<number, TreeNode<any>>();

  public ngOnInit() {
    if (this.descriptor.metadatas === null) {
      console.warn('Cannot build a tree field with no metadata', this);
      return;
    }
    const items = this.descriptor.metadatas.items;
    if (items === null) {
      console.warn('Cannot build a tree field with no items in metadata', this);
      return;
    }

    items.forEach(item => this.lookupMap.set(item.value, {
      text: item.display,
      value: item.value,
      data: item,
      selectable: item.selectable !== undefined ? item.selectable : true,
      visible: true,
      children: []
    }));

    const sortByDisplay = (a, b) => a.text.localeCompare(b.text);
    for (const item of Array.from(this.lookupMap.values()).sort(sortByDisplay)) {
      const parent: TreeNode<any> = this.lookupMap.get(item.data.parentValue);
      if (parent !== undefined) {
        parent.children.push(item);
      } else {
        this.roots.push(item);
      }
    }
  }

  public addTransId(value: any) {
    if (value) {
      const listItem: any = this.descriptor.metadatas.items.find((item: any) => item.value === value);
      if (listItem) {
        this.value.transId = listItem.display;
      }
    }
  }
}
